<div [attr.id]="generatedId(randomId)" [class]="class" [innerHTML]="sanitized"></div>


<!--<ng-template #popContent>
    <div class="row my-2">
        <strong>{{entidade?.sigla || ""}} - {{(usuario?.apelido)?.toUpperCase()|| "Sem informação"}}</strong>
    </div>
    <div class="row">
        <strong>Email</strong><br>
        <p class="ml-2">{{usuario?.email || "Sem email"}}</p>
    </div>
    <div class="row">
        <strong>Telefone</strong><br>
        <p class="ml-2">{{usuario?.telefone || "Sem telefone"}}</p>
    </div>
    <div class="row">
        <strong>Situação funcional</strong><br>
        <p class="ml-2">{{lookup.getValue(lookup.USUARIO_SITUACAO_FUNCIONAL, usuario?.situacao_funcional) || "Não informado"}}</p>
    </div>
</ng-template>
<ng-template #popTitle><b>Informação do usuário</b></ng-template>
<span type="button" class="btn btn-outline-secondary" style="color:black;border:none;background-color: lightgray;border-radius:12px;padding:0px 5px 0px 5px" [ngbPopover]="popContent" [popoverTitle]="popTitle">
	{{usuario?.nome || "Sem nome"}}
</span>-->
